/* eslint-disable no-restricted-globals */
import { put, takeLatest } from "redux-saga/effects"

import { get as getUser } from "data/actions/user/auth"
import { GENERAL_HIDE_MODAL, USER_LOGIN_SUCCESS } from "data/constants"

function* loginSuccess() {
  yield put({
    type: GENERAL_HIDE_MODAL,
    name: "auth",
  })
  yield put(getUser())
}

export default function* main() {
  yield takeLatest(USER_LOGIN_SUCCESS, loginSuccess)
}
